import { ValidPage } from '@/types/PartnerConfig';

export enum CobrandedPartnerName {
  Cigna = 'cigna',
}
export const COBRANDED_PARTNER_IDS: Record<CobrandedPartnerName, string> = {
  [CobrandedPartnerName.Cigna]: '004-CIG',
};

export const COBRANDED_PARTNERS: Record<
  string,
  {
    displayName: string;
    logo: string;
    tenant: string;
    validPages: ValidPage[];
    icon?: string;
  }
> = {
  '004-CIG': {
    displayName: 'cigna',
    logo: 'cigna',
    tenant: 'cigna',
    validPages: [
      'select',
      'delivery',
      'review',
      'summary',
      'sizing',
      'email',
      'maintenance',
      'invalid-email',
      'review-enrollment',
    ],
  },
};
